export default {
      id: "ic_milli_piyango-usage",
      viewBox: "0 0 40 40",
      url: "/" + "images/icons.3.109.2.svg#ic_milli_piyango-usage",
      toString: function () {
        return this.url;
      }
    }